import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { number, object, string } from 'yup';

import { useToast } from 'Component/Alerta';
import BotaoLink from 'Component/BotaoLink';
import Cabecalho from 'Component/Cabecalho';
import Form, { Botao, Campo } from 'Component/Form';
import LayoutDefault from 'Component/Layout';
import CategoriaDeCurriculo from 'Interface/CategoriasDeCurriculo';
import {
  useEditarCategoriaDeCurriculoMutation,
  useRecuperarCategoriaDeCurriculoQuery,
} from 'View/Service/Default/CategoriasDeCurriculo';

const regras = object({
  usuario_id: number().nullable().optional(),
  nome: string().required('Obrigatório'),
});

const Editar = (): React.ReactElement => {
  const navegacao = useNavigate();
  const toast = useToast();
  const { id = 0 } = useParams();
  const [editarCategoria] = useEditarCategoriaDeCurriculoMutation();

  const { data: { categoria } = {}, isLoading } =
    useRecuperarCategoriaDeCurriculoQuery(id);

  const enviar = async (dados: CategoriaDeCurriculo): Promise<void> => {
    try {
      await editarCategoria(dados).unwrap();

      toast({ conteudo: 'Editado com sucesso!', tema: 'success' });

      navegacao('/categorias-de-curriculo');
    } catch (error) {
      toast({
        titulo: 'Erro ao editar',
        conteudo: 'Verifique os logs para maiores detalhes.',
        tema: 'danger',
      });
    }
  };

  return (
    <LayoutDefault>
      <Cabecalho
        titulo="Editando categoria"
        descricao="Altere o formulário e clique em enviar para editar a categoria"
      />
      <Form
        onSubmit={enviar}
        inicial={categoria}
        desabilitado={isLoading}
        regras={regras}
      >
        <div className="row justify-content-center">
          <div className="col-md-4">
            <div className="bg-white shadow-sm rounded p-4">
              <Campo name="nome" rotulo="Nome" />
              <div className="mt-5">
                <Botao>Enviar</Botao>
                <BotaoLink
                  tema="light"
                  to="/categorias-de-curriculo"
                  className="ms-2"
                >
                  Cancelar
                </BotaoLink>
              </div>
            </div>
          </div>
        </div>
      </Form>
    </LayoutDefault>
  );
};

export default Editar;
